/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ReportAccessModeRepresentation } from '@veeam-vspc/models/web-controllers';

export type ReportAccessMode = ReportAccessModeRepresentation;
export const ReportAccessMode = ReportAccessModeRepresentation;
